/* eslint-disable */
import { getAuth } from "firebase/auth";

/**
 * download 2*2 dhd bordereaux pdf from nest print agent api
 * @param {string[]} trackings
 * @param {string} apiBase
 * @param {Object} merchantUser
 */
export async function printDhdBordereaux(trackings, apiBase, merchantUser) {
  const list = [...new Set((trackings || []).map(String).filter(Boolean))];
  if (list.length === 0) {
    const err = new Error("NO_TRACKINGS");
    err.code = "NO_TRACKINGS";
    throw err;
  }

  const user = getAuth().currentUser;
  if (!user) {
    const err = new Error("NOT_AUTHENTICATED");
    err.code = "NOT_AUTHENTICATED";
    throw err;
  }

  const token = await user.getIdToken();
  const res = await fetch(
    `${apiBase.replace(/\/$/, "")}/print-agent/bordereaux`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/pdf",
        "ngrok-skip-browser-warning": "true",
      },
      body: JSON.stringify({ trackings: list, user: merchantUser }),
    },
  );

  if (!res.ok) {
    let message = "REQUEST_FAILED";
    try {
      const data = await res.json();
      message = data?.message || data?.error || message;
    } catch {
      // ignore
    }
    const err = new Error(message);
    err.code = "REQUEST_FAILED";
    err.serverMessage = message;
    throw err;
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `bordereaux-dhd-${Date.now()}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// order was sent to dhd
export function isDhdOrder(order) {
  return String(order?.DC) === "3";
}
